import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "@reach/router";
import { Button, Row, Col, Spin, Form, Input } from "antd";
import moment from "moment";
import { PageTitle } from "../../../_components";
import { reportingDashboardActions } from "../../../_actions";

const ReportUpdate = ({ cancelEdit, currentId, setIsModalVisible, page }) => {
  const { currentReport, isEditReportLoading, isViewReportLoading } =
    useSelector((state) => state.reportsState);

  const { user, permissions } = useSelector((state) => state.currentUser);

  const { firstName, lastName } = user;
  const { editReport, getAllReports, viewReport } = reportingDashboardActions;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // useState for the form fields
  const [merchantName, setMerchantName] = useState("");
  const [merchantCategoryCode, setMerchantCategoryCode] = useState("");
  const [merchantPhysicalAddr, setMerchantPhysicalAddr] = useState("");
  const [merchantAddressLgaCode, setMerchantAddressLgaCode] = useState("");
  const [gpsInfo, setGpsInfo] = useState("");
  const [caseId, setCaseId] = useState("");
  const [registrationReference, setRegistrationReference] = useState("");
  const [registrationType, setRegistrationType] = useState("");
  const [status, setStatus] = useState("");
  const [remoteStatus, setRemoteStatus] = useState("");
  const [createdDate, setCreatedDate] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [contactName, setContactName] = useState("");
  const [contactTitle, setContactTitle] = useState("");
  const [mobilePhone, setMobilePhone] = useState("");
  const [email, setEmail] = useState("");
  const [terminalType, setTerminalType] = useState("");
  const [terminalId, setTerminalId] = useState("");
  const [terminalModelDescription, setTerminalModelDescription] = useState("");
  const [bankAccNo, setBankAccNo] = useState("");
  const [bankCode, setBankCode] = useState("");
  const [merchantAcquirerId, setMerchantAcquirerId] = useState("");
  const [visaAcquirerIdNumber, setVisaAcquirerIdNumber] = useState("");
  const [mastercardAcquirerIdNumber, setMastercardAcquirerIdNumber] =
    useState("");
  const [businessOccupationCode, setBusinessOccupationCode] = useState("");
  const [ptspCode, setPtspCode] = useState("");
  const [updatedBy, setUpdatedBy] = useState("");

  const [data, setData] = useState({});

  // useEffect to get the current report
  useEffect(() => {
    const onSuccessCallback = () => {};
    dispatch(viewReport(currentId, onSuccessCallback));
  }, [currentId, dispatch]);

  useEffect(() => {
    if (currentReport) {
      setMerchantName(currentReport.merchantName);
      setMerchantCategoryCode(currentReport.merchantCategoryCode);
      setMerchantPhysicalAddr(currentReport.merchantPhysicalAddr);
      setMerchantAddressLgaCode(currentReport.merchantAddressLgaCode);
      setGpsInfo(currentReport.gpsInfo);
      setCaseId(currentReport.caseId);
      setRegistrationReference(currentReport.registrationReference);
      setRegistrationType(currentReport.registrationType);
      setStatus(currentReport.status);
      setRemoteStatus(currentReport.remoteStatus);
      setCreatedDate(currentReport.createdDate);
      setStateCode(currentReport.stateCode);
      setContactName(currentReport.contactName);
      setContactTitle(currentReport.contactTitle);
      setMobilePhone(currentReport.mobilePhone);
      setEmail(currentReport.email);
      setTerminalType(currentReport.terminalType);
      setTerminalId(currentReport.terminalId);
      setTerminalModelDescription(currentReport.terminalModelDescription);
      setBankAccNo(currentReport.bankAccNo);
      setBankCode(currentReport.bankCode);
      setMerchantAcquirerId(currentReport.merchantAcquirerId);
      setVisaAcquirerIdNumber(currentReport.visaAcquirerIdNumber);
      setMastercardAcquirerIdNumber(currentReport.mastercardAcquirerIdNumber);
      setBusinessOccupationCode(currentReport.businessOccupationCode);
      setPtspCode(currentReport.ptspCode);
      setUpdatedBy(`${firstName} ${lastName}`);
    }
  }, [currentReport, firstName, lastName]);

  const saveEdit = (e) => {
    e.preventDefault();
    const updatedReport = {
      merchantName: merchantName,
      merchantCategoryCode: merchantCategoryCode,
      merchantPhysicalAddr: merchantPhysicalAddr,
      merchantAddressLgaCode: merchantAddressLgaCode,
      gpsInfo: gpsInfo,
      caseId: caseId,
      registrationReference: registrationReference,
      registrationType: registrationType,
      status: status,
      remoteStatus: remoteStatus,
      // createdDate: moment(createdDate).format("yyyy-MM-dd HH:mm:ss"),
      stateCode: stateCode,
      contactName: contactName,
      contactTitle: contactTitle,
      mobilePhone: mobilePhone,
      email: email,
      terminalType: terminalType,
      terminalId: terminalId,
      terminalModelDescription: terminalModelDescription,
      bankAccNo: bankAccNo,
      bankCode: bankCode,
      merchantAcquirerId: merchantAcquirerId,
      visaAcquirerIdNumber: visaAcquirerIdNumber,
      mastercardAcquirerIdNumber: mastercardAcquirerIdNumber,
      businessOccupationCode: businessOccupationCode,
      ptspCode: ptspCode,
      updatedBy: updatedBy,
    };
    const onSuccessCallback = () => {
      cancelEdit();
      setIsModalVisible(false);
      dispatch(getAllReports(page));
    };

    dispatch(editReport(currentReport.id, updatedReport, onSuccessCallback));
  };

  return (
    <div>
      <Spin
        spinning={isEditReportLoading || isViewReportLoading}
        tip="Loading Report..."
        size="large"
      >
        <div
        // style={{
        //   // to align to the center with #fff background color
        //   margin: "auto",
        //   width: "100%",
        //   maxWidth: "1200px",
        //   padding: "3rem",
        //   backgroundColor: "#fff",
        // }}
        >
          <Row
            type="flex"
            justify="space-between"
            style={{
              marginBottom: "1rem",
              padding: "0 2rem",
            }}
          >
            <Row gutter={32} type="flex">
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Merchant Name </label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={merchantName}
                      onChange={(e) => setMerchantName(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Merchant Category Code</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={merchantCategoryCode}
                      onChange={(e) => setMerchantCategoryCode(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>

              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">
                    Merchant Physical Address
                  </label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={merchantPhysicalAddr}
                      onChange={(e) => setMerchantPhysicalAddr(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">
                    Merchant Address LGA Code
                  </label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={merchantAddressLgaCode}
                      onChange={(e) =>
                        setMerchantAddressLgaCode(e.target.value)
                      }
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">GPS Information</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={gpsInfo}
                      onChange={(e) => setGpsInfo(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Case ID</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={caseId}
                      onChange={(e) => setCaseId(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Registration Reference</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={registrationReference}
                      onChange={(e) => setRegistrationReference(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Registration Type</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={registrationType}
                      onChange={(e) => setRegistrationType(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Status</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Remote Status</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={remoteStatus}
                      onChange={(e) => setRemoteStatus(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Date Created</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={
                        // createdDate in format yyyy-MM-dd HH:mm:ss
                        createdDate
                          ? moment(createdDate).format("yyyy-MM-dd HH:mm:ss")
                          : ""
                      }
                      onChange={(e) => setCreatedDate(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">State Code</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={stateCode}
                      onChange={(e) => setStateCode(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>

              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Contact Name </label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={contactName}
                      onChange={(e) => setContactName(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Contact Title </label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={contactTitle}
                      onChange={(e) => setContactTitle(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Phone Number</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={mobilePhone}
                      onChange={(e) => setMobilePhone(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Email Address</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Terminal Type</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={terminalType}
                      onChange={(e) => setTerminalType(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Terminal ID</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={terminalId}
                      onChange={(e) => setTerminalId(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">
                    Terminal Model Description
                  </label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={terminalModelDescription}
                      onChange={(e) =>
                        setTerminalModelDescription(e.target.value)
                      }
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Bank Account Number</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={bankAccNo}
                      onChange={(e) => setBankAccNo(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>

              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Bank Code</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={bankCode}
                      onChange={(e) => setBankCode(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Merchant Acquirer ID</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={merchantAcquirerId}
                      onChange={(e) => setMerchantAcquirerId(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Visa Acquirer Id Number</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={visaAcquirerIdNumber}
                      onChange={(e) => setVisaAcquirerIdNumber(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">
                    Mastercard Acquirer Id Number
                  </label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={mastercardAcquirerIdNumber}
                      onChange={(e) =>
                        setMastercardAcquirerIdNumber(e.target.value)
                      }
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Business Occupation Code</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={businessOccupationCode}
                      onChange={(e) =>
                        setBusinessOccupationCode(e.target.value)
                      }
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">PTSP Code</label>
                  <span className="view-text">
                    <Input
                      name=""
                      value={ptspCode}
                      onChange={(e) => setPtspCode(e.target.value)}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item>
                  <label className="view-label">Updated By</label>
                  <span className="view-text">
                    <Input name="" value={updatedBy} disabled />
                  </span>
                </Form.Item>
              </Col>
            </Row>
          </Row>
          <div
            style={{
              textAlign: "right",
              marginBottom: "5rem",
              marginTop: "2rem",
            }}
          >
            <Button style={{ width: "5rem" }} onClick={() => cancelEdit()}>
              Cancel
            </Button>
            <Button style={{ width: "5rem" }} type="primary" onClick={saveEdit}>
              Save
            </Button>
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default ReportUpdate;
